var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeHide = function SvgEyeHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-hide_svg__a)",
    stroke: "#73777A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.95 16.95A8.392 8.392 0 0 1 12 18.667C6.167 18.667 2.833 12 2.833 12A15.375 15.375 0 0 1 7.05 7.05m3.2-1.517a7.601 7.601 0 0 1 1.75-.2c5.833 0 9.167 6.667 9.167 6.667a15.412 15.412 0 0 1-1.8 2.658m-5.6-.891a2.5 2.5 0 1 1-3.534-3.534M2.833 2.833l18.334 18.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-hide_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgEyeHide;